
import React from 'react';
import { Card } from '@/components/ui/card';
import { Family } from '@/types/models';
import BillingStatusBadge from '../BillingStatusBadge';
import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface FamilyDetailStatusBarProps {
  family: Family;
  parentsCount: number;
  studentsCount: number;
}

const FamilyDetailStatusBar: React.FC<FamilyDetailStatusBarProps> = ({
  family,
  parentsCount,
  studentsCount
}) => {
  return (
    <Card className="p-4 mb-4">
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <div className="text-sm font-medium text-muted-foreground flex items-center gap-2">
            Family Account Status
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <HelpCircle className="h-4 w-4" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>This indicates whether the family's account is paid, has payments due, or isn't being billed.</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <div className="flex items-center gap-4">
            <BillingStatusBadge status={family.billing_status || 'inactive'} showTooltip={false} />
            <div className="text-sm">
              {parentsCount} {parentsCount === 1 ? 'Parent' : 'Parents'} · {studentsCount} {studentsCount === 1 ? 'Student' : 'Students'}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default FamilyDetailStatusBar;
